<template>
  <div
    ref='graph'
    :class='[isFullScreen ? "full-screen-graph" : "normal-screen-graph", isVertical ? "vertical-screen" : "horizontal-screen"]'
    class="graph-div"
  >
    <div class='quote-graph-flex'>
      <!-- 盘口插槽 -->
      <slot
        v-if='isFullScreen'
        name='header'
      ></slot>
      <!-- tab操作栏 -->
      <div
        class="tab-div"
        v-if='showTabBar'
      >
        <div class="tabLeft">
          <TabController
            :tab-list='tabList'
            :tap-tab='tapTab'
            :period='period'
            :custom-key='customKey'
          ></TabController>
          <!-- 分时图类型下拉菜单 -->
          <div
            v-if="showTrendMapType && period==10"
            @mouseleave="showTrendTypeDrop=false"
            class="tab-div-map"
          >
            <div
              @click.stop="showTrendTypeDrop = !showTrendTypeDrop"
              class="tab-menu"
            >
              <img
                :src="trendMapTypeSrc"
                class="item-icon"
              />
              <span class="text">{{trendMapType}}</span>
              <img
                src="../../assets/image/icon/icon-arrow.png"
                width="10"
                :class="showTrendTypeDrop?'active-arrow':''"
              />
            </div>
            <ul
              v-if="showTrendTypeDrop"
              class="tab-menu-item"
            >
              <li
                v-for="item in trendMapTypeList"
                :key="item.key"
                :data="item.key"
                @click.stop="changeTrendMapType"
              >
                <img
                  v-if="item.text==='分时'"
                  src="../../assets/image/icon/grident.png"
                  class="item-icon"
                />
                <img
                  v-else
                  src="../../assets/image/icon/line.png"
                  class="item-icon"
                />
                {{item.text==='分时'?'Area line':item.text}}
              </li>
            </ul>
          </div>
          <!-- k线图类型下拉菜单 -->
          <div
            v-if="showklineMapType"
            @mouseleave="showKlineTypeDrop=false"
            class="tab-div-map"
            @click.stop="showKlineTypeDrop = !showKlineTypeDrop"
          >
            <div class="tab-menu">
              <img
                :src="klineMapIconSrc"
                class="item-icon"
              />
              <span class="text">{{klineMapTypeText}}</span>
              <img
                src="../../assets/image/icon/icon-arrow.png"
                width="10"
                :class="showKlineTypeDrop?'active-arrow':''"
              />
            </div>
            <ul
              v-show="showKlineTypeDrop"
              class="tab-menu-item"
            >
              <li
                @click.stop="tapKlineMapType(item.key)"
                v-for="(item) in klineMapTypeLists"
                v-bind:key="item.key"
                :data="item.key"
              >
                <img
                  src="../../assets/image/icon/kline_us.png"
                  class="item-icon"
                  v-if="item.key === 11"
                />
                <img
                  src="../../assets/image/icon/line.png"
                  class="item-icon"
                  v-else-if="item.key === 12"
                />
                <img
                  src="../../assets/image/icon/grident.png"
                  class="item-icon"
                  v-else-if="item.key === 13"
                />
                <img
                  src="../../assets/image/icon/kline.png"
                  class="item-icon"
                  v-else
                />
                <span>{{item.text}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="tabRight">
          <div
            v-if="showForexKlineType"
            class="tab-div-map"
            @mouseleave="showForeignType=false"
            @click.stop="showForeignType = !showForeignType"
          >
            <div class="tab-menu">
              <span class="text">{{foreignTypeText}}</span>
              <img
                src="../../assets/image/icon/icon-arrow.png"
                width="10"
                :class="showForeignType?'active-arrow':''"
              />
            </div>
            <ul
              v-show="showForeignType"
              class="tab-menu-item"
            >
              <li
                @click.stop="tapKlineForeignType(item.key)"
                v-for="(item) in foreignTypeLists"
                v-bind:key="item.key"
                :data="item.key"
              >
                <span>{{item.text}}</span>
              </li>
            </ul>
          </div>

          <div
            v-if='showMainMenuBtn'
            class="tab-div-map"
            @mouseleave="showKlineMainMenu=false"
            @click.stop="showKlineMainMenu=!showKlineMainMenu"
          >
            <div :class='["quote-graph-menu-span","tab-menu", "quote-graph-tab-active"]'>
              <span class="text">{{klineMainText}}</span>

              <img
                src="../../assets/image/icon/icon-arrow.png"
                width="10"
                :class="showKlineMainMenu?'active-arrow':''"
              />
            </div>
            <ul
              v-show='showKlineMainMenu'
              class='tab-menu-item'
            >
              <li
                v-for='(item) in klineValidMains'
                @click.stop='tapKlineMenu(item.key)'
                :data='item.key'
                :key='item.key'
              >
                <span>{{item.text}}</span>
              </li>
            </ul>
          </div>

          <!-- 均线 BOLL KD密码 -->
          <div
            v-show='isFullScreen'
            v-if='showTrendJZBtn'
            @click.stop='tapMain(JZ_KEY)'
            class='tab-div-map quote-graph-jz-btn'
          >{{hasJZAuth ? "9转选股" : "鲸奇9转"}}</div>
          <!-- 主视图底部按钮栏 -->
          <div class='quote-graph-main-btns tab-div-map'>
            <!--            //除复权-->
            <!--            <div v-if='showRightBtn' @click.stop='changeKlineStatus' class='quote-graph-kline-right'>{{rightText}}</div>-->
            <div
              v-if='showRightBtn'
              @click.stop='showRightBtnMenu=!showRightBtnMenu'
              class="tab-div-map"
              @mouseleave="showRightBtnMenu=false"
            >
              <div :class='["quote-graph-menu-span","tab-menu", "quote-graph-tab-active"]'>
                <span class="text">{{rightText}}</span>
                <img
                  src="../../assets/image/icon/icon-arrow.png"
                  width="10"
                  :class="showRightBtnMenu?'active-arrow':''"
                />
              </div>
              <ul
                v-show='showRightBtnMenu'
                class='tab-menu-item'
              >
                <li
                  v-for='item in klineRightMenu'
                  :key='item.id'
                  :data='item.key'
                  @click.stop='changeKlineStatus'
                >{{item.text}}</li>
              </ul>
            </div>
            <div
              v-if='showScaleBtn'
              @click.stop='enlarge'
              style="height: 24px;width: 24px;"
              :class='["quote-graph-enlarge-btn", {"quote-graph-btn-useless": !enlargeBtnAvail}]'
            >
              <img
                src="../../assets/image/k_enlarge_pink.png"
                class="right-btn"
              >
            </div>
            <div
              v-if='showScaleBtn'
              @click.stop='narrow'
              style="height: 24px;width: 24px;"
              :class='["quote-graph-narrow-btn", {"quote-graph-btn-useless": !narrowBtnAvail}]'
            >
              <img
                src="../../assets/image/k_narrow_pink.png"
                class="right-btn"
              >
            </div>
          </div>
          <!-- 辅视图底部按钮栏 -->
          <div class='quote-graph-foot-btns tab-div-map'>
            <div
              v-if='showElectricBtn'
              @click.stop='tapFoot(ELECTRIC_KEY)'
              class='quote-graph-kline-electric'
            ></div>
            <div
              v-if='showFullBtn'
              @click.stop='setGraphStatus'
              class='full-screen-btn'
            ></div>
          </div>
        </div>
      </div>
      <!-- 外汇分笔 -->
      <tickChart
        v-show="showForexTickChart"
        :prod_code="code"
        :throttle="throttle"
      ></tickChart>
      <!-- 正常视图（分时k线等） -->
      <div
        v-show="!showForexTickChart"
        class='quote-graph-container'
      >
        <!-- canvas容器 -->
        <div
          ref='graphComponent'
          :class='["quote-graph-component", {"quote-graph-success": isLoaded}]'
          @mousewheel='wheel'
          @mousemove='mouseMove'
          @mouseleave="mouseLeave"
        >

        </div>
        <div
          v-show='!isFullScreen'
          v-if='showTrendJZBtn'
          @click.stop='tapMain(JZ_KEY)'
          class='quote-graph-jz-btn'
        >{{hasJZAuth ? "9转选股" : "鲸奇9转"}}</div>

        <!-- 分时五档明细 -->
        <!-- <div v-show='isShowDetail' class="quote-side-wrap">
          <SideDetail
            :base-size='baseSize'
            :is-loaded='isLoaded'
            :trend-status='trendStatus'
            :tab-list='trendDetailList'
            :change-side='changeSide'
            :offer-grp='offer_grp'
            :bid-grp='bid_grp'
            :tick='tick'
            :fundflow-in='fundflowIn'
            :fundflow-out='fundflowOut'
          ></SideDetail>
        </div> -->
        <!-- K线全屏右菜单栏 -->
        <div
          v-show='showFootMenu'
          class='quote-graph-klinemenu-right'
        >
          <div class='quote-graph-klinemenu-flex'>
            <!-- K线除复权 -->
            <div
              v-if='showRightMenu'
              v-for='item in klineRightMenu'
              :key='item.id'
              :data='item.key'
              :class='[
                "quote-graph-menu-item",
                "quote-graph-menu-right",
                {"quote-graph-item-active": item.key === klineStatus},
                {"quote-graph-item-useless": item.key !== klineStatus && !showKlineRight}
              ]'
              @click.stop='changeKlineStatus'
            >{{item.text}}</div>
            <!-- K线辅视图列表 -->
            <div
              v-for='item in klineValidFoots'
              :key='item.key'
              :data='item.key'
              :class='[
                "quote-graph-menu-item",
                {"quote-graph-item-active": item.key === footContextKey}
              ]'
              @click.stop='changeKlineContext'
            >{{item.text}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 兼容IE
import "core-js/es6";
import 'core-js/fn/string/pad-start';
// 存在循环加载，优先加载Conf
import { Conf } from '../../viewmodel/config.js';
import Util, {
  mergeOption,
  resizeObserver,
  bind,
  unBind,
  nextTick,
  numberFormat,
  curryDebounce,
  preventScale,
} from '../../util/index.js';
import { checkExchange } from '../../controller/util'
import {
  checkFootBlackList,
  beforeLog,
} from '../../controller/util.js';
import Component from '../../viewmodel/component/index.js';
import {
  TREND_ONE,
  TREND_FIVE,
  KLINE_ONEMIN,
  KLINE_FIVEMIN,
  KLINE_FIFMIN,
  KLINE_THIMIN,
  KLINE_SIXMIN,
  KLINE_ONEDAY,
  KLINE_ONEWEEK,
  KLINE_ONEMONTH,
  KLINE_ONEYEAR,
  TREND_TYPE,
  KLINE_TYPE,
  KLINE_MAP_TYPE,
  KLINE_PRICE_TYPE,
  KEY_MAP,
  NET_STATUS,
} from '../../viewmodel/index.js';
import Controller from '../../controller/index.js';
import TabController from './tab.vue';
import SideDetail from './side.vue';
import tickChart from './forex/tickChart.vue';
import '../../assets/style/index.scss';
// import Countly from 'countly/packages';
import Bus from '../eventBus.js';
const {
  TREND_KEY,
  MA_KEY,
  JZ_KEY,
  KD_KEY,
  BOLL_KEY,
  AREA_KEY,
  AMOUNT_KEY,
  MACD_KEY,
  KDJ_KEY,
  ENE_KEY,
  ELECTRIC_KEY,
  FUNDFLOW_KEY,
  FUNDFLOWDIR_KEY,
  MAIN_STATUS,
} = KEY_MAP;
const { TRADING_PRICE, GOOD_BUY_PRICE, GOOD_SELL_PRICE, END_PRICE, CENTER_PRICE } = KLINE_PRICE_TYPE
const {
  KLINE_NONE,
  KLINE_BEFORE,
  KLINE_AFTER,
} = KLINE_TYPE;
const {
  KLINE,
  KLINE_US,
  KLINE_AREA,
  KLINE_LINE
} = KLINE_MAP_TYPE;
const { TREND_WD, TREND_MX, TREND_CJ } = TREND_TYPE;
/**** 配置tab列表 ****/
const tabList = [
  // { key: TREND_ONE, text: '分时' },//10
  // { key: TREND_FIVE, text: '五日' },//11
  // { key: KLINE_ONEDAY, text: '日线' },//6
  // { key: KLINE_ONEWEEK, text: '周线' },//7
  // { key: KLINE_ONEMONTH, text: '月线' },//8
  // { key: KLINE_ONEYEAR, text: '年线' },//9
  // { key: KLINE_ONEMIN, text: '1分', foldText: '1分钟' },//1
  // { key: KLINE_FIVEMIN, text: '5分', foldText: '5分钟' },//2
  // { key: KLINE_FIFMIN, text: '15分', foldText: '15分钟' },//3
  // { key: KLINE_THIMIN, text: '30分', foldText: '30分钟' },//4
  // { key: KLINE_SIXMIN, text: '60分', foldText: '60分钟' },//5
  { key: TREND_ONE, text: 'Time sharing' },//10
  { key: TREND_FIVE, text: '5MA' },//11
  { key: KLINE_ONEDAY, text: 'Day line' },//6
  { key: KLINE_ONEWEEK, text: 'Perimeter' },//7
  { key: KLINE_ONEMONTH, text: 'Lunar line' },//8
  { key: KLINE_ONEYEAR, text: 'Annual line' },//9
  { key: KLINE_ONEMIN, text: '1 min', foldText: '1分钟' },//1
  { key: KLINE_FIVEMIN, text: '5 min', foldText: '5分钟' },//2
  { key: KLINE_FIFMIN, text: '15 min', foldText: '15分钟' },//3
  { key: KLINE_THIMIN, text: '30 min', foldText: '30分钟' },//4
  { key: KLINE_SIXMIN, text: '60 min', foldText: '60分钟' },//5
];
// 需要折叠时tabList的配置 {key: KLINE_ONEMIN, text: '1分', fold: true, foldText: '1分钟'},
const detailList = [
  { key: TREND_WD, text: '五档' },
  { key: TREND_MX, text: '明细' },
  { key: TREND_CJ, text: '成交' },
];
const klineRightMenu = [
  { key: KLINE_NONE, text: '不复权', id: 0 },
  { key: KLINE_BEFORE, text: '前复权', id: 3 },
  { key: KLINE_AFTER, text: '后复权', id: 6 },
];
const klineMapTypeList = [
  { key: KLINE, text: 'K-line diagram' },
  { key: KLINE_US, text: 'American line' },
  { key: KLINE_AREA, text: 'Area line' },
  { key: KLINE_LINE, text: 'broken line' }
];
const foreignTypeLists = [
  { key: TRADING_PRICE, text: '成交价' },
  { key: GOOD_BUY_PRICE, text: '最优买价' },
  { key: GOOD_SELL_PRICE, text: '最优卖价' },
  { key: END_PRICE, text: '16:30收盘价' },
  { key: CENTER_PRICE, text: '中间价' }
];
const defaultOption = {
  remTopx: 50,
  showTabBar: true,
  showMapType: true,
  showFullScreenBtn: false,
  showSideDetail: false,
  showFundflow: false,
  supportFullScreen: false,
  supportGestures: false,
  supportKlineRight: false,
  supportKlineScale: false,
  supportKlineFootMenu: false,
  showCursor: true,
  showTrendAvg: true
};
const { VolumnPie, BaseContext } = Conf;
const mapList = (array, ratioFixed, text) => {
  if (Util.isArray(array)) {
    return array.map((a, i) => {
      return {
        ...a,
        price: a.price.toFixed(ratioFixed),
        amount: numberFormat(a.amount),
        key: (text || 0) + i,
      }
    })
  }
  return array;
};
const fundflowList = (array, text) => {
  return array.map((a, i) => {
    let percent = parseFloat(a.rate);
    if (!Util.isValidNumber(percent)) {
      percent = 0;
    } else {
      percent = percent / 200;
    }
    return {
      ...a,
      amount: numberFormat(a.amount),
      color: VolumnPie[a.primaryKey],
      percent,
      key: (text || 0) + i,
    }
  });
};
// const lineIcon = require('../../assets/image/icon/line.png')
// const klineIcon = require('../../assets/image/icon/kline.png')
// const areaIcon = require('../../assets/image/icon/grident.png')
// const usIcon = require('../../assets/image/icon/kline_us.png')
import { getIndex } from '../../util/index.js'
import lineIcon from '../../assets/image/icon/line.png'
import klineIcon from '../../assets/image/icon/kline.png'
import areaIcon from '../../assets/image/icon/grident.png'
import usIcon from '../../assets/image/icon/kline_us.png'
// import Vue from 'vue'
export default {
  name: 'QuoteView',
  data() {
    return {
      loadMore: true,
      loadMoreTime: null,
      earnMore: true,
      earnMoreTime: null,
      store: null,
      options: null,
      fontSize: undefined,
      positionObserve: null,
      graph: null,
      tabList: [],
      klineRightMenu,
      showTrendMapType: true,
      klineMapTypeLists: klineMapTypeList,
      foreignTypeLists,
      showKlineMainMenu: false,
      showRightBtnMenu: false,
      curryResize: null,
      moveWatcher: null,
      JZ_KEY,
      ELECTRIC_KEY,
      showTrendTypeDrop: false, // 是否展示切换图形的下拉列表
      trendMapType: 'Area line',
      showKlineTypeDrop: false, // 是否展示切换图形的下拉列表
      showForeignType: false, //是否展示外汇分类
      key: 2,
      showForexTickChart: false, // 是否展示外汇分笔
      customKey: undefined // 针对tab栏设置的自定义key
    }
  },
  components: {
    TabController,
    SideDetail,
    tickChart
  },
  props: {
    appkey: {
      type: String,
    },
    business_type: {
      type: String,
    },
    multiMainModules: {
      type: Number,
      required: true,
    },
    multiMainAuths: {
      type: Number,
      required: true,
    },
    multiFootModules: {
      type: Number,
      required: true,
    },
    multiFootAuths: {
      type: Number,
      required: true,
    },
    option: {
      type: Object,
      default: () => ({})
    },
    graphConfig: {
      type: Object
    },
    throttle: {
      type: Number,
      default: 0
    },
    threshold: {
      type: Number,
      default: 3000,
    },
    cid: {
      type: String,
      required: true,
    },
    params: {
      type: Object
    },
    token: {
      type: String,
    },
    periodBlackList: {
      type: Array,
      default: () => ([]),
    },
    code: {
      type: [Number, String],
      required: true,
    },
    mainKey: {
      type: [Number, String], // 当组件作为单独的指标时，需要与tab完成联动
      default: 0
    },
    rightKey: {
      type: Number, //除权前复后复
      default: 0
    },
    scaleKey: {
      type: Array, // 缩放
      default: () => { [] }
    },
    moveKey: {
      type: Object,
      default: () => { { } }
    },
    instantId: { // 用于简单区分当前实例
      type: Number
    }
  },
  computed: {
    narrowBtnAvail() {
      let { start, end, period, maxLen, len, stepLen } = this.store.state;
      const nowLen = (end - start);
      const noMore = [KLINE_ONEYEAR, KLINE_ONEMIN, KLINE_FIVEMIN, KLINE_FIFMIN, KLINE_THIMIN, KLINE_SIXMIN].some(item => item === period)
      if (noMore || len < 200) {
        return nowLen < maxLen;
      }
      // if(start<0){start=0}
      // &&period!=KLINE_ONEYEAR;//年线加载更多的时候报错
      return start > stepLen
    },
    enlargeBtnAvail() {
      const { start, end, minLen, stepLen } = this.store.state;
      const nowLen = end - start;
      if (start + stepLen >= end) {
        return false
      }
      return nowLen > minLen
    },
    supportGestures() {
      return this.options.supportGestures;
    },
    showKlineRight() {
      return this.store.state.isShowKlineRight;
    },
    showTabBar() {
      return this.options.showTabBar;
    },
    showMapType() {
      return this.options.showMapType;
    },
    showScaleBtn() {
      return this.options.supportKlineScale && this.isKline;
    },
    showRightBtn() {
      return this.options.supportKlineRight
        && this.showKlineRight
        && this.isKline
        && !this.store.state.isFullScreen;
    },
    showRightMenu() {
      return this.options.supportKlineRight
        && this.isKline
        && this.store.state.isFullScreen;
    },
    showklineMapType() {
      return this.isKline && this.klineMapTypeLists.length > 1;
    },
    showForexKlineType() {
      return this.isKline && this.foreign;
    },
    showFootMenu() {
      return this.options.supportKlineFootMenu
        && this.isKline
        && this.store.state.isFullScreen
    },
    showMainMenuBtn() {
      // !this.kLineMapKey表示仅在k线图时 展示其他选项
      return this.isKline && this.klineValidMains.length > 1 && !this.kLineMapKey;
    },
    showFullBtn() {
      return this.options.supportFullScreen && this.options.showFullScreenBtn;
    },
    // 显示分时九转按钮
    showTrendJZBtn() {
      return this.showJZBtn && this.period === TREND_ONE;
    },
    // 显示电波选股按钮
    showElectricBtn() {
      return this.hasElectricAuth && this.footContextKey === ELECTRIC_KEY;
    },
    // 显示九转按钮
    showJZBtn() {
      return this.store.state.mainChain && (this.store.state.mainChain.has(a => a.key === JZ_KEY));
    },
    // 电波权限
    hasElectricAuth() {
      return this.store.state.footChain && (this.store.state.footChain.has(a => a.key === ELECTRIC_KEY && !a.noauth));
    },
    // 九转权限
    hasJZAuth() {
      return this.multiMainAuths & JZ_KEY;
    },
    isLoaded() {
      return this.store.state.status === NET_STATUS.LOADED;
    },
    isTouchMove() {
      return this.store.state.isPress && this.store.state.current;
    },
    isShowDetail() {
      return this.options.showSideDetail && this.store.state.isShowDetail;
    },
    isVertical() {
      return this.store.state.isVertical;
    },
    isFullScreen() {
      return this.store.state.isFullScreen;
    },
    isKline() {
      return [
        KLINE_ONEMIN,
        KLINE_FIVEMIN,
        KLINE_FIFMIN,
        KLINE_THIMIN,
        KLINE_SIXMIN,
        KLINE_ONEDAY,
        KLINE_ONEWEEK,
        KLINE_ONEMONTH,
        KLINE_ONEYEAR,
        KLINE_PRICE_TYPE
      ].indexOf(this.customKey) > -1;
    },
    period() {
      return this.store.state.period;
    },
    klineStatus() {
      return this.store.state.klineStatus;
    },
    trendMapTypeList() {
      const mainChain = this.store.state.mainChain;
      let trendTabs = [];
      if (Util.isDef(mainChain)) {
        const value = mainChain.values();
        trendTabs = value;
      }
      return trendTabs;
    },
    klineValidMains() {
      const mainChain = this.store.state.mainChain;
      let mains = [];
      if (Util.isDef(mainChain)) {
        const value = mainChain.values()
        mains = value;
      }
      return mains;
    },
    klineValidFoots() {
      const footChain = this.store.state.footChain;
      let foots = [];
      if (Util.isDef(footChain)) {
        const value = footChain.values();
        foots = value;
      }
      return foots;
    },
    klineMainText() {
      const item = this.klineValidMains.find(a => a.key === this.mainContextKey);
      if (Util.isDef(item)) {
        return item.text;
      }
      return '';
    },
    klineMapTypeText() {
      if (!this.kLineMapKey) {
        return this.klineMapTypeLists[0].text
      }
      const item = this.klineMapTypeLists.find(a => a.key === this.kLineMapKey);
      if (Util.isDef(item)) {
        return item.text;
      }
      return '';
    },
    foreignTypeText() {
      const business_type = this.store.state.business_type
      if (!business_type) {
        return this.foreignTypeLists[0].text
      }
      const item = this.foreignTypeLists.find(a => a.key === business_type);
      if (Util.isDef(item)) {
        return item.text;
      }
      return '';
    },
    mainContextKey() {
      this.showKlineMainMenu = false;
      return this.store.state.mainContextKey;
    },
    kLineMapKey() {
      this.showKlineTypeDrop = false;
      return this.store.state.kLineMapKey || 0;
    },
    //   business_type(){
    //     this.showForeignType=false
    //     return this.store.state.business_type || 0;
    // },
    footContextKey() {
      return this.store.state.footContextKey;
    },
    baseSize() {
      return this.store.state.baseSize;
    },
    trendDetailList() {
      const chain = this.store.state.detailChain;
      let detail = [];
      if (Util.isDef(chain)) {
        const value = chain.values();
        detail = detailList.filter(a => value.find(b => b === a.key));
      }
      return detail;
    },
    trendStatus() {
      return this.store.state.trendStatus;
    },
    bid_grp() {
      const { ratioFixed } = this.store.state.sealObj;
      return mapList(this.store.state.bid_grp, ratioFixed, 5);
    },
    offer_grp() {
      const { ratioFixed } = this.store.state.sealObj;
      return mapList(this.store.state.offer_grp, ratioFixed, 0);
    },
    tick() {
      const { ratioFixed } = this.store.state.sealObj;
      return mapList(this.store.state.tick, ratioFixed, 0);
    },
    fundflowIn() {
      return fundflowList(this.store.state.fundflowIn, 0);
    },
    fundflowOut() {
      return fundflowList(this.store.state.fundflowOut, 3);
    },
    rightText() {
      const rightMap = {
        [KLINE_NONE]: '不复权',
        [KLINE_BEFORE]: '前复权',
        [KLINE_AFTER]: '后复权',
      };
      return rightMap[this.klineStatus];
    },

    moduleConfig() {
      return {
        multiMainModules: this.multiMainModules,
        multiMainAuths: this.multiMainAuths,
        multiFootModules: this.multiFootModules,
        multiFootAuths: this.multiFootAuths
      }
    },
    // k线当前选中类型的图标
    klineMapIconSrc() {
      switch (this.kLineMapKey) {
        case 11:
          return usIcon;
          break;
        case 12:
          return lineIcon;
          break;
        case 13:
          return areaIcon;
        default:
          return klineIcon;
          break;
      }
    },
    // 分时图当前选中类型的图标
    trendMapTypeSrc() {
      if (this.trendMapType === 'Area line') {
        return areaIcon
      } else {
        return lineIcon
      }
    },
    foreign() {
      return checkExchange(this.code)
    }

  },
  created() {
    this.options = mergeOption({}, defaultOption, this.option);
    const { cid, token, threshold, params, instantId } = this;
    this.store = new Controller({ cid, token, threshold, params, instantId });
    // Vue.prototype.store=this.store
    // if (this.appkey) {
    //   Countly.init({appkey: this.appkey, version});
    //   this.store.commit('setLog', Countly('customEvent'));
    // }
    // 设置是否显示分时成交
    this.store.commit('setFundFlowStatus', this.options.showFundflow);
    this.store.state.isShowTrendAvg = this.options.showTrendAvg;
    this.tabList = tabList.filter(a => !this.periodBlackList.find(b => {
      return b === a.key
    }));
    if (this.foreign) {
      this.tabList = [{ key: 12, text: '分笔' }].concat(this.tabList)
    }
    // 设置定时请求时间间隔
    this.store.commit('setThrottle', this.throttle);
    if (Util.isObject(this.graphConfig)) {
      // 单独实例设置样式参数
      this.store.commit('setGraphConfig', this.graphConfig);
    }
    this.setModules();
    this.moveWatcher = this.$watch('isTouchMove', function(newVal) {
      if (!this.isKline) return;
      if (!Util.isBoolean(newVal)) {
        // 触发光标显示
        const { kline } = this.store.state;
        this.$emit('touchMove', {
          isTouch: true,
          ...kline[newVal]
        });
      } else {
        this.$emit('touchMove', {
          isTouch: false
        });
      }
    })
  },
  mounted() {
    this.graph = new Component(this.$refs.graphComponent, {
      parent: this,
      store: this.store,
      supportHammer: this.supportGestures
    });
    // 监听body的变化，计算画布offsetTop和offsetLeft
    // TODO 监听body变化，使用时应避免不断增删dom节点，已加入300ms防抖，后续再优化
    if (this.supportGestures) {
      this.positionObserve = resizeObserver(curryDebounce(this._calcOffset, this, 300));
      this.positionObserve.observe(document.body);
    }
    this.curryResize = curryDebounce(this.resize, this, 16);
    bind(window, 'resize', this.curryResize);
    preventScale();
    this._watch();
    this.resize();
    if (Util.isValidArray(this.tabList)) {
      const key = this.tabList[0].key;
      this.tapTab(key);
    }
    if (this.$route.path == "/Finance/Xinhua500Index") {
      document.getElementsByClassName('quote-graph-component')[0].style.height = '53vh'
      document.getElementsByClassName('quote-graph-component')[1].style.height = '16vh'
      document.getElementsByClassName('quote-graph-component')[1].style.marginTop = '-15px'
    } else if (this.$route.path == "/ChinaInformationV2/1" || this.$route.path == "/ChinaInformationV2/:id") {
      document.getElementsByClassName('quote-graph-component')[0].style.height = '19vh'
      document.getElementsByClassName('quote-graph-component')[1].style.height = '19vh'
      document.getElementsByClassName('quote-graph-component')[1].style.marginTop = '0px'
    } else {
      document.getElementsByClassName('quote-graph-component')[0].style.height = '24vh'
      document.getElementsByClassName('quote-graph-component')[1].style.height = '19vh'
      document.getElementsByClassName('quote-graph-component')[1].style.marginTop = '0px'
    }
    // document.addEventListener("click", e => {
    //   if (!this.$el.contains(e.target)) {
    //     this.showTrendTypeDrop = false;
    //   }
    // });
  },
  watch: {
    business_type(val) {
      this.tapKlineForeignType(val)
    },
    code(val) {
      const { period } = this.store.state;
      this.tapTab(period || this.tabList[0].key);
    },
    throttle(newVal) {
      this.store.commit('setThrottle', newVal);
    },
    'moduleConfig': {
      handler: 'setModules'
    },
    mainKey(val) {
      if (!val) {
        return
      }
      this.tapTab(val)
    },
    rightKey(val) {
      this.changeKlineStatus(val)
    },
    scaleKey(val) {
      if (val && val[0]) {
        this.store.commit(val[0])
      }
    },
    ForeignCode(val) {
      if (val && val[0]) {
        this.store.commit(val[0])
      }
    },
    moveKey(val) {
      this.mouseMove('', val)
    }
  },
  methods: {
    changeFootState(key) {
      this.store.dispatch('changeFootState', key)
    },
    _watch() {
      this.store.watch({
        key: ['isFullScreen', 'isVertical'],
        fn: this.getEleMatrix.bind(this)
      });
    },
    setModules() {
      // 设置有效主视图KEY
      this.store.commit('setMainModules', {
        modules: this.multiMainModules,
        auths: this.multiMainAuths
      });
      // 设置有效辅视图KEY
      this.store.commit('setFootModules', {
        modules: this.multiFootModules,
        auths: this.multiFootAuths
      });
    },

    async tapTab(key) {
      this.customKey = key
      if (this.foreign) {
        this.store.state.business_type = TRADING_PRICE
        Bus.$emit('getBusTapKey', [this.code, key]);
        if (key === 12) {
          this.showForexTickChart = true
          this.customKey = 12
          return
        }
        this.showForexTickChart = false
        this.store.commit('getForeignCode', [this.code, key, TRADING_PRICE]);
      } else {
        this.store.dispatch('drawGraph', [this.code, key]);
        Bus.$emit('getBusTapKey', [this.code, key]);
      }
    },
    /**
     * 点击分时页面鲸奇9转按钮埋点
     */
    tapMain(key) {
      const { MAIN_STATUS } = this.store.state;
      const item = MAIN_STATUS[this.period].find(a => a.key === key);
      if (item) {
        let hasAuth = false;
        if (!item.noauth) {
          hasAuth = true;
        }
        this.$emit('tapGraph', {
          module: key,
          view: 'main',
          hasAuth
        });
      }
    },

    tapFoot(key) {
      const { FOOT_STATUS } = this.store.state;
      const item = FOOT_STATUS[this.period].find(a => a.key === key);
      if (item) {
        let hasAuth = false;
        if (!item.noauth) {
          hasAuth = true;
        }
        this.$emit('tapGraph', {
          module: key,
          view: 'foot',
          hasAuth
        });
      }
    },
    /**
     * 点击K线页面策略选项按钮埋点
     */
    async tapKlineMenu(e) {
      this.showKlineMainMenu = !this.showKlineMainMenu
      if (!this.isKline) return;
      const { klineStatus } = this.store.state;
      const id = e;
      const item = this.klineValidMains.find(a => a.key === id);
      if (item) {
        const key = item.key;
        if (this.mainContextKey === key) return;
        if (item.noauth) {
          this.$emit('tapGraph', {
            module: item.key,
            view: 'main',
            hasAuth: false
          });
        } else {
          this.store.dispatch('changeMainState', key);
        }
      }
    },
    //切换外汇类型
    tapKlineForeignType(key) {
      this.showForeignType = !this.showForeignType
      if (key === END_PRICE || key === CENTER_PRICE) {
        this.klineMapTypeLists = klineMapTypeList.slice(2, 4)
      } else {
        this.klineMapTypeLists = klineMapTypeList
      }

      const item = this.foreignTypeLists.find(a => a.key === key);
      if (item) {
        // if(this.foreignTypeText === item.text) {
        //     return
        // }
        this.store.dispatch('getForeignCode', [this.code, this.period, key]);
        Bus.$emit('changeForeign', key);
      }
      this.store.state.business_type = key
    },
    /*
    * 点击切换k线图的类型
     */
    tapKlineMapType(key) {
      this.showKlineTypeDrop = !this.showKlineTypeDrop
      if (!this.isKline) {
        return
      }
      const item = this.klineMapTypeLists.find(a => a.key === key);
      if (item) {
        if (this.klineMapTypeText === item.text) {
          return
        }
        this.store.state.kLineMapKey = item.key
        this.store.dispatch('changeMainState', item.key);
      }
    },
    changeSide(key) {
      this.store.dispatch('changeSide', key);
    },
    // 设置K线除复权状态
    changeKlineStatus(e) {
      // if (!this.showKlineRight) return;
      this.showRightBtnMenu = false
      // 指标组件联动时主图还未绘完，此时会导致指标数据不切换直接返回，故先注释掉
      let status = undefined
      if (typeof e === 'number') {
        status = e
      } else {
        status = e.target.getAttribute('data')
      }
      const { klineStatus } = this.store.state;
      // const status = e.target.getAttribute('data') || undefined;
      if (klineStatus === status) return;
      this.store.dispatch('changeKlineStatus', Number(status));
      Bus.$emit('changeKlineStatus', Number(status))
    },
    // 设置当前分时图类型
    changeTrendMapType(e) {
      if (!this.showTrendMapType) return;
      this.showTrendTypeDrop = false
      const currentTrendMapType = this.store.state;
      const mapType = e.target.getAttribute('data') || undefined;
      if (currentTrendMapType === mapType) return;
      this.trendMapType = mapType === "1" ? 'Area line' : 'broken line'
      this.store.dispatch('changeMainState', Number(mapType))
    },
    // 设置K线辅视图Context
    changeKlineContext(e) {
      const id = e.target.getAttribute('data');
      const item = this.klineValidFoots.find(a => a.key === id);
      if (item) {
        const { key } = item;
        this.store.dispatch('changeFootState', key);
      }
    },
    resize() {
      const { supportFullScreen } = this.options;
      const { isVertical, isFullScreen } = this.store.state;
      const isVerticalNew = Math.abs(window.orientation) !== 90;
      if (isVertical ^ isVerticalNew) {
        if (supportFullScreen) {
          isVertical ^ isFullScreen && this.setGraphStatus(!isFullScreen, false); // 否则切换全屏状态
        }
        // 横竖屏状态与isVertical不一致，重置isVertical
        this.setScreenDirection(isVerticalNew);
      } else if (isVertical && isFullScreen) {
        this.setGraphSize(); // 竖屏下全屏resize需重置节点大小
      } else {
        // 初始化isVertical为undefined时，横屏设置方向和全屏状态
        if (!Util.isBoolean(isVertical)) {
          this.setScreenDirection(isVerticalNew);
          !isVerticalNew && !isFullScreen && this.setGraphStatus(!isFullScreen, false);
        }
      }
      this.$nextTick(this.setFontSize)
    },
    setFontSize() {
      let fontSize;
      const { remTopx = 50 } = this.options;
      if (this.option.remTopx) {
        const { isVertical, isFullScreen } = this.store.state;
        const width = document.documentElement.clientWidth || document.body.clientWidth;
        const height = document.documentElement.clientHeight || document.body.clientHeight;
        if (isFullScreen) {
          if (isVertical) {
            fontSize = Math.min(width * remTopx / 375, height * remTopx / 667);
          } else {
            fontSize = Math.min(width * remTopx / 667, height * remTopx / 375);
          }
        } else {
          fontSize = width * remTopx / 375;
        }
        // 全屏时调整root字体大小
        document.documentElement.style.fontSize = fontSize + 'px';
      } else {
        fontSize = parseFloat(document.documentElement.style.fontSize);
      }
      const baseSize = fontSize / remTopx * 12;
      this.store.commit('setBaseSize', baseSize);
    },
    /*
    * 鼠标移动
    */
    mouseMove(e, coord) {
      if (this.options.showCursor === false) {
        return
      }
      // 增加对是否canvas的判断
      if (coord) {
        if (coord.instant === this.instantId) {
          return
        }
        // 随另一个quoteview发生的联动
        const { clientX, pageX } = coord
        this.store.commit('mousemove', { clientX, pageX })
      } else if (e) {
        // 自身鼠标移动
        const { clientX, clientY, pageX, pageY } = e
        const instant = this.instantId
        this.store.commit('mousemove', { clientX, clientY, pageX, pageY })
        Bus.$emit('mouseMoving', { clientX, clientY, pageX, pageY, instant })
      }
    },

    // 鼠标离开
    mouseLeave(e) {
      this.store.commit('mouseleave', 0)
      Bus.$emit('mouseMoving', { pageX: 0 })
    },

    wheel(e) {
      const _this = this
      // K线缩放
      if (this.isKline) {
        const deltaY = e.deltaY || e.wheelDelta;
        if (this.showScaleBtn) {
          if (deltaY > 0 && this.narrowBtnAvail) {
            if (this.loadMore) {
              clearTimeout(_this.loadMoreTime)
              this.loadMore = false
              this.narrow();
              this.loadMoreTime = setTimeout(function() {
                _this.loadMore = true
              }, 50)
            }
            // this.narrow();
          } else if (deltaY < 0 && this.enlargeBtnAvail) {
            if (this.earnMore) {
              clearTimeout(_this.earnMoreTime)
              this.earnMore = false
              this.enlarge();
              this.earnMoreTime = setTimeout(function() {
                _this.earnMore = true
              }, 50)
            }
            // this.enlarge();
          }
        }
        e.preventDefault();
      }
    },
    enlarge() {
      if (!this.enlargeBtnAvail) {
        return
      }
      this.showScaleBtn && this.store.commit('enlarge');
      Bus.$emit('indicatorScale', 'enlarge')
    },
    narrow() {
      const { len, start, end } = this.store.state
      if (!this.narrowBtnAvail) {
        return
      }
      // if(len>600){
      //     this.store.state.kLineMapKey = KLINE_LINE
      //     this.store.dispatch('changeMainState', KLINE_LINE);
      // }
      this.showScaleBtn && this.store.commit('narrow');
      Bus.$emit('indicatorScale', 'narrow')
    },
    // 设置isFullScreen
    setGraphStatus(status, resetSize = true) {
      const { isFullScreen } = this.store.state;
      if (isFullScreen === status) return;
      if (!Util.isBoolean(status)) {
        status = !isFullScreen;
      }
      if (!this.options.supportFullScreen && status) return; // 不支持全屏
      this.store.commit('setGraphStatus', status);
      this.$emit('setGraphStatus', status);
      resetSize && this.$nextTick(this.setFontSize)
    },
    // 设置isVertical
    setScreenDirection(status) {
      const { isVertical } = this.store.state;
      if (isVertical === status) return;
      if (!Util.isBoolean(status)) {
        status = !isVertical;
      }
      this.store.commit('setScreenDirection', status);
    },
    setGraphSize() {
      const { isFullScreen, isVertical } = this.store.state;
      const width = document.documentElement.clientWidth || document.body.clientWidth;
      const height = document.documentElement.clientHeight || document.body.clientHeight;
      if (isFullScreen) {
        if (isVertical) {
          this.$refs.graph.style.width = height + 'px';
          this.$refs.graph.style.height = width + 'px';
        } else {
          this.$refs.graph.style.width = this.$refs.graph.style.height = '';
        }
      } else {
        this.$refs.graph.style.width = this.$refs.graph.style.height = '';
      }
    },
    /**
     * 监听isVertical和isFullScreen
     * 设置坐标变换矩阵和变换原点
     * 调用setGraphSize设置ele的size
     */
    getEleMatrix() {
      /**
       * 需等到getGraphStatus和getScreenDirection完成后回调
       * 以保证transformOrigin和transform的正确
       */
      nextTick(() => {
        this.setGraphSize();
        if (!this.supportGestures) return;
        this._calcOffset();
        const style = window.getComputedStyle(this.$refs.graph, null);
        const transformOrigin = style.transformOrigin || style.webkitTransformOrigin;
        const [originX, originY] = transformOrigin.match(/[\d\.]+/ig).map(a => Number.parseFloat(a));
        const transform = style.transform || style.webkitTransform;
        const transformMatrix = (/matrix(?:|3d)\(([\s\S]+)\)/ig).exec(transform);
        let matrix = [
          [1, 0, 0],
          [0, 1, 0],
          [0, 0, 1]
        ];
        if (Util.isArray(transformMatrix) && transformMatrix.length > 1) {
          const matrixArray = transformMatrix[1].match(/[^,\s]+/ig);
          if (Util.isArray(matrixArray)) {
            const array = matrixArray.map(a => {
              // 处理精度缺失
              const number = Math.round(Number.parseFloat(a) * 10) / 10;
              if (Util.isValidNumber(number)) {
                return number;
              }
            });
            if (matrixArray.length === 6) {
              // 2d变换
              // 构造3*3变换矩阵
              matrix = [
                [array[0], array[1], 0],
                [array[2], array[3], 0],
                [array[4], array[5], 1]
              ];
            } else if (matrixArray.length === 16) {
              // 3d变换
              matrix = [[], [], [], []];
              for (let i = 0; i < 16; i++) {
                const column = i % 4;
                matrix[column].push(array[i]);
              }
            }
          }
        }
        this.store.commit('setEleMatrix', { matrix, transformOrigin: [originX, originY] });
      });
    },
    _calcOffset() {
      this.graph && this.graph._calcOffset.call(this.graph);
      let pageX = 0;
      let pageY = 0;
      let ele = this.$refs.graph;
      while (ele) {
        const { offsetLeft = 0, offsetTop = 0 } = ele;
        pageX += offsetLeft;
        pageY += offsetTop;
        ele = ele.offsetParent;
      }
      this.store.commit('setElePosition', { position: [pageX, pageY] });
    },
  },
  beforeDestroy() {
    if (this.graph) {
      this.graph.destroy();
      this.graph = null;
    }
    if (this.positionObserve) {
      this.positionObserve.unobserve(document.body);
      this.positionObserve = null;
    }
    if (this.curryResize) {
      unBind(window, 'resize', this.curryResize);
      this.curryResize = null;
    }
    if (this.store) {
      this.store.commit('destroy');
      this.store = null;
    }
  },
  activated() {
    this.store.commit('setActivate', true);
  },
  deactivated() {
    this.store.commit('setActivate', false);
  }
}
</script>
<style lang="scss" scoped>
.graph-div {
  background-color: #f6f8fa;
}
.active-arrow {
  transform: rotateX(180deg);
}
.tab-div {
  height: 34px;
  line-height: 34px;
  display: flex;
  justify-content: space-between;
  /*position: relative;*/
  // font-size: 13px;
  width: 100%;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
  // box-shadow: 0 2px 10px 0 rgba(78,171,249,0.2);
  margin-bottom: 2px;
  color: #333333;
  .tabLeft {
    display: flex;
    align-items: center;
  }
  > .tabRight {
    margin-right: 20px;
    display: flex;
    align-items: center;
  }
  .tab-div-map {
    margin-left: 10px;
    position: relative;
    z-index: 200;
    font-size: 14px;
    .tab-menu {
      display: flex;
      flex-direction: row;
      align-items: center;
      > .text {
        width: max-content;
        min-width: 30px;
        margin: 0 5px 0 4px;
      }
    }
    ul,
    li {
      padding: 0;
      margin: 0;
      list-style: none;
    }
    .tab-menu-item {
      position: absolute;
      top: 34px;
      left: -10px;
      background-color: #fff;
      border: 1px solid #399bff;
      white-space: nowrap;
      /*min-width: 115px;*/
      > li {
        height: 30px;
        line-height: 30px;
        padding: 0 12px;
        &:hover {
          background-color: #e3f2ff;
        }
      }
    }
  }
  .item-icon {
    width: 18px;
    height: 18px;
    vertical-align: middle;
  }
}
.quote-graph-container {
  background-color: #fff;
}
.right-btn {
  border-radius: 50%;
  height: 24px;
  width: 24px;
  color: #0070e0;
  text-align: center;
  z-index: 10;
}
</style>
